import type React from "react";
import { IconButton } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { useRewardsModal } from "app/pages/digital-suite/home-page/components/Rewards/useRewardsModal";
import { SideTabWrapper, SideTabContentContainer } from "./SideTab.styled";
import { useDraggableSideTab } from "app/custom-hooks/useDraggableSideTab";

export const RewardsSideBar: React.FC = () => {
    const { rewardsModalComponent, handleOpenModal: openRewards } = useRewardsModal();

    const { wrapperRef, dragState, horizontalOffset, verticalOffsetDelta, handleMouseDown } = useDraggableSideTab({
        trackingEvent: "Homepage/open rewards",
        verticalOffsetAdjustment: 60,
        onClick: openRewards,
    });

    return (
        <>
            <SideTabWrapper
                ref={wrapperRef}
                id={"rewards-side-tab"}
                isDragged={dragState}
                verticalOffset={verticalOffsetDelta}
                sideOffset={horizontalOffset}
                onMouseDown={handleMouseDown}
            >
                <SideTabContentContainer>
                    <IconButton
                        type={"flat"}
                        iconName={"gift"}
                    >
                        {translate("rewards_tab.button")}
                    </IconButton>
                </SideTabContentContainer>
            </SideTabWrapper>
            {rewardsModalComponent}
        </>
    );
};
